export const mapColor = [
  '#5086F3',
  '#5EC8F1',
  '#69D19C',
  '#F5D242',
  '#F19E55',
  '#F17C86',
  '#AD53D4',
  '#7F6FF1',
  '#488E89',
  '#6E7794',
  '#6F80F1',
  '#50B2F3',
  '#5EF1D3',
  '#D0E15B',
  '#ECB758',
  '#F17555',
  '#D453C7',
  '#956FE7',
  '#5D9AB3',
  '#737CB2',
  // 目前设计只提供20种颜色，剩余颜色用旧的
  'rgba(55,106,231,0.4)',
  'rgba(62,203,255,0.4)',
  'rgba(79,203,135,0.4)',
  'rgba(255,209,116,0.4)',
  'rgba(237,145,66,0.4)',
  'rgba(233,95,106,0.4)',
  'rgba(207,97,172,0.4)',
  'rgba(129,100,205,0.4)',
  'rgba(101,133,247,0.4)',
  'rgba(160,182,250,0.4)',
  'rgba(55,106,231,0.4)',
  'rgba(62,203,255,0.4)',
  'rgba(79,203,135,0.4)',
  'rgba(255,209,116,0.4)',
  'rgba(237,145,66,0.4)',
  'rgba(233,95,106,0.4)',
  'rgba(207,97,172,0.4)',
  'rgba(129,100,205,0.4)',
  'rgba(101,133,247,0.4)',
  'rgba(160,182,250,0.4)',
];
// 2025 /4 /16 新色卡
export const mapColors = [
  'rgba(55,106,231,1)',
  'rgba(62,203,255,1)',
  'rgba(79,203,135,1)',
  'rgba(255,209,116,1)',
  'rgba(237,145,66,1)',
  'rgba(233,95,106,1)',
  'rgba(207,97,172,1)',
  'rgba(129,100,205,1)',
  'rgba(101,133,247,1)',
  'rgba(160,182,250,1)',

  // 目前设计只提供20种颜色，剩余颜色用旧的
  'rgba(55,106,231,0.4)',
  'rgba(62,203,255,0.4)',
  'rgba(79,203,135,0.4)',
  'rgba(255,209,116,0.4)',
  'rgba(237,145,66,0.4)',
  'rgba(233,95,106,0.4)',
  'rgba(207,97,172,0.4)',
  'rgba(129,100,205,0.4)',
  'rgba(101,133,247,0.4)',
  'rgba(160,182,250,0.4)',
  'rgba(55,106,231,0.4)',
  'rgba(62,203,255,0.4)',
  'rgba(79,203,135,0.4)',
  'rgba(255,209,116,0.4)',
  'rgba(237,145,66,0.4)',
  'rgba(233,95,106,0.4)',
  'rgba(207,97,172,0.4)',
  'rgba(129,100,205,0.4)',
  'rgba(101,133,247,0.4)',
  'rgba(160,182,250,0.4)',
];

/** 主颜色里的子矩阵树的配色 */
export const mapColorMap = {
  '#5086F3': [
    '#0F1E59',
    '#0F1E59',
    '#0F1E59',
    '#172F80',
    '#1F3E96',
    '#3965CC',
    '#5086F3',
    '#6B9DFA',
    '#7DADFF',
    '#A6C9FF',
    '#BED9FF',
    '#CFE4FF',
  ],
  '#5EC8F1': [
    '#153D59',
    '#153D59',
    '#153D59',
    '#1F5A80',
    '#307DA6',
    '#45A1CC',
    '#5EC8F1',
    '#79D7F9',
    '#8CE2FF',
    '#B5EFFF',
    '#CDF4FF',
    '#DEF9FF',
  ],
  '#69D19C': [
    '#13382A',
    '#13382A',
    '#13382A',
    '#215E45',
    '#358561',
    '#4DAB7D',
    '#69D19C',
    '#81D8AA',
    '#92DEB4',
    '#C0EBD2',
    '#D2EFDD',
    '#DEF2E4',
  ],
  '#F5D242': [
    '#5C410A',
    '#5C410A',
    '#5C410A',
    '#826010',
    '#A8831D',
    '#CFA92D',
    '#F5D242',
    '#FBDE5C',
    '#FFE76E',
    '#FFF196',
    '#FFF5AC',
    '#FFF9BF',
  ],
  '#F19E55': [
    '#592911',
    '#592911',
    '#592911',
    '#803F19',
    '#A65B29',
    '#CC7B3D',
    '#F19E55',
    '#F9B370',
    '#FFC182',
    '#FFD8AB',
    '#FFE3C3',
    '#FFECD4',
  ],
  '#F17C86': [
    '#591F2C',
    '#591F2C',
    '#591F2C',
    '#802E3D',
    '#A64453',
    '#CC5E6B',
    '#F17C86',
    '#F9979E',
    '#FFABAF',
    '#FFCCCC',
    '#FFDBDB',
    '#FFE6E6',
  ],
  '#AD53D4': [
    '#270D3B',
    '#270D3B',
    '#270D3B',
    '#431761',
    '#642787',
    '#873BAD',
    '#AD53D4',
    '#BB6ADA',
    '#C57BE0',
    '#DFB2ED',
    '#EBC9F4',
    '#F3D9FA',
  ],
  '#7F6FF1': [
    '#1B1C59',
    '#1B1C59',
    '#1B1C59',
    '#292880',
    '#413CA6',
    '#5E54CC',
    '#7F6FF1',
    '#9B8BF9',
    '#AD9EFF',
    '#D2C8FD',
    '#E3DDFE',
    '#EFEBFF',
  ],
  '#488E89': [
    '#0A1B1C',
    '#0A1B1C',
    '#0A1B1C',
    '#1B4242',
    '#245552',
    '#3F716E',
    '#488E89',
    '#609D97',
    '#70A7A0',
    '#A9C7C3',
    '#C7D9D7',
    '#DCE6E4',
  ],
  '#6E7794': [
    '#000000',
    '#000000',
    '#000000',
    '#141521',
    '#2E3247',
    '#4C526E',
    '#6E7794',
    '#858CA6',
    '#949BB3',
    '#B8BED1',
    '#C9D0DC',
    '#D6DCE5',
  ],
  '#6F80F1': [
    '#212652',
    '#212652',
    '#212652',
    '#2C348A',
    '#424DAF',
    '#5967D5',
    '#6F80F1',
    '#8C9AFF',
    '#A1ACFF',
    '#B7C0FF',
    '#C2C9FF',
    '#D2D7FF',
  ],
  '#50B2F3': [
    '#183552',
    '#183552',
    '#183552',
    '#284E97',
    '#346EBC',
    '#408FE1',
    '#50B2F3',
    '#73C2FF',
    '#8DCCFF',
    '#A8D8FF',
    '#BDE3FD',
    '#D4F0FC',
  ],
  '#5EF1D3': [
    '#1C4849',
    '#1C4849',
    '#1C4849',
    '#2F6E73',
    '#3C979C',
    '#4BC1C7',
    '#5EF1D3',
    '#7EF4D7',
    '#97F5E5',
    '#AFF8F3',
    '#C1FBF2',
    '#D4FFF2',
  ],
  '#D0E15B': [
    '#3E4325',
    '#3E4325',
    '#3E4325',
    '#5E652F',
    '#828B36',
    '#A7B43F',
    '#D0E15B',
    '#DAE968',
    '#E0EC90',
    '#E7F0B7',
    '#EDF2C6',
    '#F3F6D5',
  ],
  '#ECB758': [
    '#463621',
    '#463621',
    '#463621',
    '#674F20',
    '#91702F',
    '#BD933F',
    '#ECB758',
    '#EEC167',
    '#F1CE87',
    '#F5DBA7',
    '#F8E4BC',
    '#FCEDD1',
  ],
  '#F17555': [
    '#482319',
    '#482319',
    '#482319',
    '#71392B',
    '#984B32',
    '#C15E3A',
    '#F17555',
    '#F4916D',
    '#F5A58B',
    '#F8BAAA',
    '#F9C9BD',
    '#FBDAD1',
  ],
  '#D453C7': [
    '#3F193B',
    '#3F193B',
    '#3F193B',
    '#552A51',
    '#7E366D',
    '#AA428B',
    '#D453C7',
    '#E560CC',
    '#E785D7',
    '#E9A9E3',
    '#EFBBEA',
    '#F5CEF2',
  ],
  '#956FE7': [
    '#2C2148',
    '#2C2148',
    '#2C2148',
    '#3E3063',
    '#5A448C',
    '#7759C1',
    '#956FE7',
    '#A484F5',
    '#B69DF1',
    '#CAB7EE',
    '#D6C8EF',
    '#E4D9F1',
  ],
  '#5D9AB3': [
    '#1C2E34',
    '#1C2E34',
    '#1C2E34',
    '#2A484F',
    '#3A6A79',
    '#49889D',
    '#5D9AB3',
    '#71AEB6',
    '#8FBCC8',
    '#AECCDB',
    '#C0D7E4',
    '#D3E4EE',
  ],
  '#737CB2': [
    '#222531',
    '#222531',
    '#222531',
    '#333850',
    '#474D78',
    '#5C63A2',
    '#737CB2',
    '#8792C8',
    '#A0A7D1',
    '#B4B9D6',
    '#C3C9E1',
    '#D4DAEE',
  ],
  'rgba(55,106,231,0.4)': [],
  'rgba(62,203,255,0.4)': [],
  'rgba(79,203,135,0.4)': [],
  'rgba(255,209,116,0.4)': [],
  'rgba(237,145,66,0.4)': [],
  'rgba(233,95,106,0.4)': [],
  'rgba(207,97,172,0.4)': [],
  'rgba(129,100,205,0.4)': [],
  'rgba(101,133,247,0.4)': [],
  'rgba(160,182,250,0.4)': [],
};

/** 这里的color为迁移过来的，其实不用color了，可以删掉 */
export const subTreeColor = [
  { min: 1000000000, max: 100000000000, color: '#061D79' },
  { min: 500000000, max: 1000000000, color: '#061D79' },
  { min: 100000000, max: 500000000, color: '#061D79' },
  { min: 50000000, max: 100000000, color: '#0F3196' },
  { min: 10000000, max: 50000000, color: '#1A47B1' },
  { min: 5000000, max: 10000000, color: '#295CCC' },
  { min: 1000000, max: 5000000, color: '#4970E3' },
  { min: 500000, max: 1000000, color: '#6585F7' },
  { min: 100000, max: 500000, color: '#839DF8' },
  { min: 50000, max: 100000, color: '#A0B6FA' },
  { min: 10000, max: 50000, color: '#BCCEFB' },
  { min: 0, max: 10000, color: '#EBF3FE' },
];
